
import { Injectable } from '@angular/core';

@Injectable()
export class RFFConstants {
    RFF_ELEMENT_TYPE = {
        LongText: 'textBox',
        ShortText: 'text',
        ReadText: 'label',
        NumberField: 'number',
        TimePicker: 'time',
        DatePicker: 'date',
        MultiChoice: 'singleSelection',
        MultiChoiceList: 'singleSelectionList',
        CheckBox: 'multiSelection',
        CheckBoxList: 'multiSelectionList',
        UserList: 'userList',
        Location: 'gps',
        Image: 'imagePicker',
        Signature: 'signature',
        Hazard: 'hazard',
        Action: 'action',
        HazardWithLabel: 'hazardWithLabel',
        DynamicField: 'dynamic',
        MultiChoiceHeading: 'singleSelectionWithHeading',
        SectionTitle: 'sectionTitle',
        FreeFormDraw: 'freeFormDraw',
        SubForm: 'subform',
        Rating: 'rating',
        InspectionQuestion: 'inspection',
        File: 'file'
    }
    ACCEPTING_FILE_MIME_TYPES = ['image/jpeg', 'image/jpg',, 'image/png', 'image/gif', 'image/svg+xml',
        'audio/mp3', 'audio/mpeg',
        'video/mp4', 'video/mov', 'video/mpeg', 'video/quicktime',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf']
}





// WEBPACK FOOTER //
// ./src/app/rFF/constants.ts